//react
import { useEffect, useState, useRef } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { Mobile, PC } from "../../../media/MediaQuery";

//css
import styled from "styled-components";

// component
import Header from "../../../component/common/Header";
import MyMain from "./components/MyMain";
import MobileMyMain from "./components/MobileMyMain";

export default function MyMainPage({ preOrder }) {
    return (
        <>
            <PC>
                <MyMain />
            </PC>
            <Mobile>
                <MobileMyMain preOrder={preOrder} />
            </Mobile>
        </>
    );
}
